import React, { useRef } from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Modal from '@rcg/ui-react/lib/components/FullScreenModal/Modal';
import useModal from '@rcg/ui-react/lib/components/FullScreenModal/hooks';
import Theme from '@rcg/ui-react/lib/theme';
import Mobile from '../Mobile';
import InputRangeDate from '../InputRangeDate';

const InputRange = (props) => {
  const { handleDatepicker = () => {}, oneWay = false } = props;
  const isMd = useMediaQuery(Theme.breakpoints.down('md'));
  const btnOpenModal = useRef(null);
  const {
    modalProps,
    open: openModal,
    close: closeModal,
  } = useModal({
    background: '#FFF',
  });

  const handleOpenModal = (event) => {
    if (isMd) {
      openModal(btnOpenModal);
    } else {
      handleDatepicker(event);
    }
  };

  const handleCloseModal = () => {
    closeModal();
  };

  return (
    <>
      <div ref={btnOpenModal}>
        <InputRangeDate oneWay={oneWay} {...props} handleDatepicker={handleOpenModal} />
      </div>
      <Modal {...modalProps} padding={false} closeButton={false}>
        <Mobile {...props} oneWay={oneWay} handleCloseModal={handleCloseModal} />
      </Modal>
    </>
  );
};

export default InputRange;
